export enum StockItemStatus {
   InStock = 0,
   OutOfStock = 1,
   All = 2,
};
